export class CPFacet {
    constructor(public id: number, public label: string) {}
}
